import sliceCreator from '../../index.js';
import {PROFILE} from '../../../constants/index.js';
const _profileAction = sliceCreator('PROFILE',PROFILE, 'get');

const { asyncAction: profileAction, reducer, clearData: clearProfileData } = _profileAction;

export default reducer;

export {
    profileAction,
    clearProfileData
}


